/**
 * Centralized copy for the Member Books tab (ABO-managed books inside Customer
 * Information). Kept out of the component per the repo rule that feature text is
 * not hardcoded inline (mirrors MemberSecurityTab.strings.ts).
 */
export const memberBooksStrings = {
  tabTitle: "Book Access",
  inactive: "This member is not active — adding and removing books is disabled.",
  noSubscription:
    "This member has no subscription record, so books cannot be managed.",
  loadError: "Could not load this member's books. Please try again.",
  current: {
    heading: "Book access",
    headingWithCount: "Book access ({count})",
    empty: "This member has no book access yet.",
    systemBadge: "System entry",
    systemBadgeHint:
      "A non-catalog system code. It can't be removed from this screen.",
    unknownName: "Unknown book",
    remove: "Remove",
    removeAria: "Remove {name}",
    copyCodeTooltip: "Copy code",
    codeCopied: "Code copied to clipboard",
  },
  add: {
    heading: "Add books",
    filterPlaceholder: "Filter books by name…",
    filterLabel: "Search the book catalog",
    catalogError: "Could not load the book catalog. Please try again.",
    noneAvailable: "All catalog books are already on this member's account.",
    noMatches: "No books match your filter.",
    selectedCount: "{count} selected",
    clear: "Clear",
    submit: "Add selected",
    disabledHint: "Select one or more books to enable.",
    success: "Added {count} book(s) to {email}.",
    error: "Could not add the selected books. Please try again.",
  },
  removeConfirm: {
    title: "Remove this book?",
    body: 'Remove "{name}" ({code}) from {email}? This takes effect on the member\'s next login.',
    yes: "Yes, remove it",
    no: "Cancel",
    success: 'Removed "{name}" from {email}.',
    error: "Could not remove the book. Please try again.",
  },
} as const;

/**
 * Replaces `{token}` placeholders with provided values; unknown tokens are left
 * intact so missing interpolation is visible.
 */
export const formatMessage = (
  template: string,
  vars: Record<string, string | number> = {}
): string =>
  template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : match
  );
